import React from 'react'
import clsx from 'clsx'
import { displayFont } from '../../utils/ui/fonts'

type HeadingProps = { level?: 1 | 2 | 3 | 4 | 5 | 6 } & React.ComponentPropsWithoutRef<
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
>

export function Heading({ className, level = 3, ...props }: HeadingProps) {
  let Element: `h${typeof level}` = `h${level}`

  return (
    <Element
      {...props}
      className={clsx(
        displayFont.className,
        level === 1 && 'text-header1',
        level === 2 && 'text-header2',
        level === 3 && 'text-header3',
        level === 4 && 'text-header4',
        'text-primary text-balance text-center',
        'py-2',
        className,
      )}
    />
  )
}

export function Subheading({ className, level = 2, ...props }: HeadingProps) {
  let Element: `h${typeof level}` = `h${level}`

  return <Element {...props} className={clsx(className, 'text-button text-secondary text-center py-2')} />
}
